import React from "react";

class StatsBlock extends React.Component {
  render() {
    let { value, label, subvalue, onTouchTap, style } = this.props,
      styles = {
        block: {
          border: "1px solid #0288d1",
          minHeight: 88,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        },
        value: {
          fontWeight: 700,
          fontSize: "2.5em"
        },
        subvalue: {
          fontWeight: 500,
          fontSize: "0.75em"
        },
        label: {
          textTransform: "uppercase",
          marginTop: 7,
          marginBottom: -5,
          lineHeight: 1.1,
          fontSize: "1em"
        }
      };

    return (
      <div
        style={Object.assign({}, styles.block, style)}
        className={
          onTouchTap ? "statsBlock hvr-bounce-to-bottom" : "statsBlock"
        }
        onTouchTap={onTouchTap}
      >
        <div>
          <div style={styles.value}>
            {value}
            {subvalue ? (
              <span style={styles.subvalue}>{`/${subvalue}`}</span>
            ) : null}
          </div>
          <div style={styles.label}>{label}</div>
        </div>
      </div>
    );
  }
}

export default StatsBlock;



// WEBPACK FOOTER //
// ./src/app/components/partials/stats-block.jsx